import Vue from "vue";
import axios from "axios";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/widget/:host",
    meta: { layout: "widget", requiresAuth: false },
    component: () => import("../views/Widget.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/widget/Index.vue"),
        meta: { layout: "widget", requiresAuth: false },
      },
      {
        path: "schedule/:location?",
        component: () => import("../views/widget/Schedule.vue"),
        meta: { layout: "widget", requiresAuth: false },
      },
    ],
  },
  {
    path: "/:host/account",
    meta: { layout: "account", requiresAuth: true },
    component: () => import("../shared/views/Account.vue"),
    children: [
      {
        path: "index",
        component: () => import("../shared/views/account/Index.vue"),
        meta: { layout: "account", requiresAuth: true },
      },
      {
        path: "details",
        component: () => import("../shared/views/account/Index.vue"),
        meta: { layout: "account", requiresAuth: true },
      },
      {
        path: "orders",
        component: () => import("../shared/views/account/Orders.vue"),
        meta: { layout: "account", requiresAuth: true },
      },
      {
        path: "orders/past",
        component: () => import("../shared/views/account/OrdersPast.vue"),
        meta: { layout: "account", requiresAuth: true },
      },
      {
        path: "wallet",
        component: () => import("../shared/views/account/Wallet.vue"),
        meta: { layout: "account", requiresAuth: true },
      },
      {
        path: "login",
        component: () => import("../views/account/Login.vue"),
        meta: { layout: "login", requiresAuth: false },
      },
      {
        path: "verify",
        component: () => import("../views/account/Verify.vue"),
        meta: { layout: "login", requiresAuth: false },
      },
      {
        path: "register",
        component: () => import("../views/account/Register.vue"),
        meta: { layout: "login", requiresAuth: false },
      },
      {
        path: "logout",
        beforeEnter(to, from, next) {
          Vue.$cookies.remove("token");
          localStorage.removeItem("type");

          const host = to.params.host || "";

          next(`/${host}/`);
        },
      },
    ],
  },
  {
    path: "/error",
    name: "Error",
    meta: { layout: "web", requiresAuth: false },
    component: () => import("../views/pages/NotFound.vue"),
  },
  {
    path: "/:host",
    meta: { layout: "web", requiresAuth: false },
    component: () => import("../views/Shop.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/hosts/Agenda.vue"),
        meta: { layout: "web", requiresAuth: false },
      },
      {
        path: "event/:event",
        component: () => import("../shared/views/shop/Event.vue"),
        meta: { layout: "web", requiresAuth: false },
      },
      {
        path: "event/:event/:slot",
        component: () => import("../shared/views/shop/Tickets.vue"),
        meta: { layout: "web", requiresAuth: false },
      },
      {
        path: "event/:event/:slot/checkout",
        meta: { layout: "web", requiresAuth: false },
        component: () => import("../shared/views/shop/Checkout.vue"),
      },
      {
        path: "order/:order_id",
        component: () => import("../shared/views/shop/Order.vue"),
        meta: { layout: "web", requiresAuth: false },
      },
    ],
  },
  {
    path: "/*",
    name: "NotFound",
    meta: { layout: "web", requiresAuth: false },
    component: () => import("../views/pages/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }

    if (to.path === from.path) {
      return false;
    }

    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    return next();
  }

  const token = Vue.$cookies.get("token");

  if (!token) {
    return next("/account/login");
  }

  try {
    const response = await axios.post(
      "https://api.tixgo.nl/customer/check",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (response.data.status !== "success") {
      Vue.$cookies.remove("token");
      localStorage.removeItem("type");

      return next("/account/login");
    }

    next();
  } catch (error) {
    Vue.$cookies.remove("token");
    localStorage.removeItem("type");

    next("/account/login");
  }
});

router.onError((error) => {
  if (
    confirm(
      "An update is available or a network error occurred. Do you want to reload?",
    )
  ) {
    window.location.reload();
    error;
  }
});

export default router;
